import reduce from 'lodash/reduce';

const normalizeTasksStudents = response => reduce(response, (result, value, key) => {
  result[key] = reduce(value, (res, item) => res.concat(Object.keys(item.students)), []).sort((a, b) => a - b);
  return result;
}, {});

export default normalizeTasksStudents;
